import { Resume } from '@sr/types';
import React from 'react';
import { Box, Text } from '../../ui';
import ProfilePhoto from './ProfilePhoto';
import SpacingControl from './SpacingControl';
import TemplateCustomizations from './TemplateCustomizations';
import TemplatePickerModal from './TemplatePickerModal';

const Sidebar = ({
  resume,
  setLocalBaseSize,
  localBaseSize,
}: {
  resume: Resume;
  setLocalBaseSize: (arg0: number) => void;
  localBaseSize: number;
}) => {
  return (
    <Box pl={3} pt={5}>
      <Text variant="listHeadingDark" py={1}>
        Design Options
      </Text>
      <TemplatePickerModal
        resume={resume}
        setLocalBaseSize={setLocalBaseSize}
      />
      <SpacingControl
        resume={resume}
        setLocalBaseSize={setLocalBaseSize}
        localBaseSize={localBaseSize}
      />
      <ProfilePhoto resume={resume} />
      <TemplateCustomizations resume={resume} />
    </Box>
  );
};

export default Sidebar;
